<template>
  <v-autocomplete
    :items="filteredGenerations"
    @change="onChange"
    v-on:input="$emit('input', $event)"
    v-bind="this.$attrs"
  ></v-autocomplete>
</template>

<script>
import { mapGetters } from 'vuex'
import { Generation } from '@/plugins/api'
import { sortBy } from 'lodash'

export default {
  data: () => ({
    Generations: []
  }),
  props: {
    filters: Object,
    defaultGenerations: Array,
    options: Object,
    allGenerations: Array
  },
  computed: {
    ...mapGetters('app', ['department']),
    filteredGenerations() {
      let output
      if (!this.allGenerations) {
        output = this.Generations
      } else {
        output = this.Generations.filter(item => {
          return this.allGenerations.includes(item.id)
        })
      }
      return sortBy(output, i => !!i.is_graduated).map(({ name, is_graduated, ...o }) => ({
        name: `${name} ${is_graduated ? '(Đã TN)' : ''}`,
        is_graduated,
        ...o
      }))
    }
  },
  created() {
    if (this.defaultGenerations) {
      this.Generations = this.defaultGenerations
    }
    this.fetchAllGenerations()
  },
  methods: {
    async fetchAllGenerations() {
      this.Generations = await Generation.fetch({
        ...this.filters,
        department: this.department.id
      })
    },
    onChange(data) {
      this.$emit('change', data)
    }
  }
}
</script>
